import { render } from "./FooterPage.vue?vue&type=template&id=9809e36a"
import script from "./FooterPage.vue?vue&type=script&lang=js"
export * from "./FooterPage.vue?vue&type=script&lang=js"

import "./FooterPage.vue?vue&type=style&index=0&id=9809e36a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__